import React from "react";
import styles from "@/styles/layout.module.css";
import { layoutBackgrounds } from "@/assets";
import { inter, philosopher } from "@/lib/fonts";
import { Link } from "react-router-dom";
import { routes } from "@/lib/constants";
import { getHomeRouteForUser } from "@/lib/routing";
import { useSession } from "@/contexts/AuthContext";

export default function ErrorPage() {
  const { data: session } = useSession();
  const homepageLink = session
    ? getHomeRouteForUser(session.user)
    : routes.landing;

  return (
    <div
      className={`${styles.homeLayout} ${philosopher.className} flex flex-col items-center justify-center min-h-screen p-4 bg-gray-50 text-gray-900 dark:bg-gray-900 dark:text-gray-100`}
      style={layoutBackgrounds.home}
    >
      <h1 className="uppercase text-6xl text-primary font-medium pb-7 text-center dark:text-primary/90">
        Oops!
      </h1>
      <h2 className="text-2xl font-semibold mb-4 text-center text-gray-900 dark:text-gray-100">
        Something went wrong.
      </h2>
      <p
        className={`text-center mb-8 px-4 text-gray-700 dark:text-gray-300 ${inter.className}`}
      >
        An unexpected error has occurred. Please try refreshing the page or go
        back to the homepage.
      </p>
      <Link
        to={homepageLink}
        className="px-6 py-3 bg-primary text-white rounded-md hover:bg-primary-dark transition"
      >
        Go to Homepage
      </Link>
    </div>
  );
}
